import Vue from "vue";
import Vuex from "vuex";

import { sessionStorage } from "../common/storage";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navList:
      JSON.stringify(sessionStorage.get("navList")) === "{}"
        ? []
        : sessionStorage.get("navList"), //栏目列表
    id:
      JSON.stringify(sessionStorage.get("navId")) === "{}"
        ? []
        : sessionStorage.get("navId"), //栏目id
    categoryFlag:
      JSON.stringify(sessionStorage.get("categoryFlag")) === "{}"
        ? []
        : sessionStorage.get("categoryFlag"), //栏目属性
    categoryId:
      JSON.stringify(sessionStorage.get("categoryId")) === "{}"
        ? []
        : sessionStorage.get("categoryId") //父类型编号
  },
  mutations: {
    setNavList(state, data) {
      state.navList = data;
    },
    setId(state, data) {
      state.id = data;
    },
    setCategoryFlag(state, data) {
      state.categoryFlag = data;
    },
    setCategoryId(state, data) {
      state.categoryId = data;
    }
  },
  actions: {
    // 导航栏
    navList({ commit }, data) {
      sessionStorage.set("navList", data);
      commit("setNavList", data);
    },
    navId({ commit }, data) {
      sessionStorage.set("navId", data);
      commit("setId", data);
    },
    categoryFlag({ commit }, data) {
      sessionStorage.set("categoryFlag", data);
      commit("setCategoryFlag", data);
    },
    categoryId({ commit }, data) {
      sessionStorage.set("categoryId", data);
      commit("setCategoryId", data);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js